import { Capacitor } from "@capacitor/core";
import { getApiBaseUrlFromEnv } from "@/lib/env";

function rewriteLocalhostForNativeDev(baseUrl: string): string {
  if (import.meta.env.PROD || typeof window === "undefined") {
    return baseUrl;
  }

  if (!Capacitor.isNativePlatform()) {
    return baseUrl;
  }

  const platform = Capacitor.getPlatform();

  if (platform === "android") {
    return baseUrl
      .replace("localhost", "10.0.2.2")
      .replace("127.0.0.1", "10.0.2.2");
  }

  if (platform === "ios") {
    const iosDevHost = import.meta.env.VITE_IOS_DEV_HOST;
    if (typeof iosDevHost === "string" && iosDevHost.length > 0) {
      return baseUrl
        .replace("localhost", iosDevHost)
        .replace("127.0.0.1", iosDevHost);
    }
  }

  return baseUrl;
}

export function getApiBaseUrl(): string {
  const baseUrl = getApiBaseUrlFromEnv();
  return rewriteLocalhostForNativeDev(baseUrl).replace(/\/+$/, "");
}
